"use client"

import { Empty } from "@/shared/components/ui/empty"
import { Button } from "@/shared/components/ui/button"

interface NoPackagesFoundProps {
  searchTerm?: string
}

export function NoPackagesFound({ searchTerm }: NoPackagesFoundProps) {
  return (
    <div className="py-12">
      <Empty
        icon={searchTerm ? "search" : "no-packages"}
        title={searchTerm ? "No packages found" : "No packages available"}
        description={
          searchTerm
            ? `We couldn't find any travel packages matching "${searchTerm}". Try adjusting your filters or browse our available destinations.`
            : "No travel packages match your current filters. Try adjusting your selection to see more options."
        }
        variant="large"
      />
      
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <Button
          onClick={() => window.location.reload()}
          className="bg-orange-500 hover:bg-orange-600"
        >
          Reset Filters
        </Button>
        <Button 
          onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          variant="outline"
          className="border-orange-500 text-orange-500 hover:bg-orange-50"
        >
          Back to Top
        </Button>
      </div>
    </div>
  )
}
